// Fix for dropdown menu positioning when using keyboard navigation
document.addEventListener('DOMContentLoaded', function() {
  // Add CSS rule for keyboard-focused dropdowns in secondary navigation
  var style = document.createElement('style');
  style.innerHTML = `
    .site-navigation--secondary .menu--main-item.keyboard-focus .menu--dropdown {
      margin-top: -5px !important;
    }
  `;
  document.head.appendChild(style);
});
